import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6xkec2e7a: FaireProductEntity = {
  token: "p_y6xkec2e7a",
  type: "product",
  name: "Thank You with Flowers - Die Cut Card",
  brandToken: "b_extkpy9afk",
  brandName: "Isatopia",
  imageUrl:
    "https://cdn.faire.com/fastly/109659eb654465315d7284ae94c0593e43c172d1e437cda48d8b5f0dd3fa8860.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23b75e81051c6948ce25dca670f17d2a395559a0ffad9f03cc0dbc17f3b1297d.png",
    "https://cdn.faire.com/fastly/bb12026a14822e1ba174e362b9875ed9531289a5a2f45d0a6ac1f246fc18bc51.jpeg",
    "https://cdn.faire.com/fastly/d0bf128b27d0b79ade8518eaff4edb2c901ae198124b7a8061b85723feba2efc.jpeg",
    "https://cdn.faire.com/fastly/dfca1cd05b16e22bf7510fe13a0096649fad2104bc4525ca6fb85ef90ac98d8e.jpeg",
  ],
  priceDollars: 3.25,
  description:
    'A bouquet of gratitude! This die cut card is a lovely way to say "thank you" with some colorful blossoms.\n\nA6 - 6.25"x4.5" die cut folded card, printed in the USA on sustainably produced 18pt coated card stock.\n\nEach folded card is blank inside, comes with a brown kraft recycled envelope and is wrapped in a sustainable cello bag. \n\nOriginal illustrations by Isabelle. \n\nMade by French hands in the USA!\n',
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:24.905Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
